import React from 'react'
import Section1 from './Section1'

const CmsData = () => {
  return (
    <div > 
      <div>
        <Section1></Section1>
      </div>
    </div>
  )
}

export default CmsData